module.exports = __webpack_public_path__ + "static/media/Rita Cornwell Alcove units (7).319976ad.JPG";